import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {CloseGuard, DialogRef, ModalComponent} from 'ngx-modialog';
import {Domain} from '../../../utils/objects/organization';
import {ApiService} from '../../../utils/services/api.service';
import {NotificationsService} from 'angular2-notifications';

@Component({
  selector: 'app-domain-info',
  templateUrl: './domain-info.component.html',
  styleUrls: ['./domain-info.component.css']
})
export class DomainInfoComponent implements OnInit, CloseGuard, ModalComponent<any> {

  public domainForm: FormGroup;
  public domain: Domain;
  public organizationID;

  constructor(public dialog: DialogRef<any>,
              private apiService: ApiService,
              private notificationsService: NotificationsService) {
    this.organizationID = this.dialog.context.organizationID;
    this.domain = this.dialog.context.domain;
    dialog.setCloseGuard(this);
  }

  ngOnInit() {

    this.domainForm = new FormGroup({
      'domainName': new FormControl(this.domain ? this.domain.domain : null, Validators.required)
    });
  }

  saveChanges() {
    let domain = new Domain();
    domain.domain = this.domainForm.controls.domainName.value;
    if (this.domain) {
      this.apiService.updateOrganizationDomain(this.organizationID, this.domain.id, domain).subscribe(
        response => {
          this.notificationsService.success('Success', 'Domain is updated');
          this.dialog.close({type: 'UPDATED', data: response['data']});
        }, error => {
          this.notificationsService.error('Error', error.error.message);
        }
      );
    } else {
      this.apiService.addOrganizationDomain(this.organizationID, domain).subscribe(
        response => {
          this.notificationsService.success('Success', 'Domain is added');
          this.dialog.close({type: 'ADDED', data: response['data'].organization});
        }, error => {
          console.log(error);
          this.notificationsService.error('Error', error.error.message);
        }
      );
    }
  }


  closeModal() {
    this.dialog.close({type: 'DEFAULT'});
  }

  beforeDismiss(): boolean {
    return true;
  }

  beforeClose(): boolean {
    return false;
  }

}



// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/main/frames/domain-info/domain-info.component.ts